import { createClient } from "@supabase/supabase-js";

// Same-origin by default: Caddy fronts /auth/v1 and /rest/v1 on the app's own
// host (backend/Caddyfile.snippet), so one build works on any hostname.
// Session storage key and implicit OAuth flow are supabase-js defaults —
// identical to the previous frontend's, so signed-in users stay signed in.
const url = import.meta.env.VITE_SUPABASE_URL || window.location.origin;
const key = import.meta.env.VITE_SB_PUBLISHABLE_KEY;
if (!key) throw new Error("VITE_SB_PUBLISHABLE_KEY was not set at build time");

// Read before createClient: supabase-js consumes and clears an OAuth redirect's
// hash during its own initialisation, which starts in the constructor.
export const initialHash = window.location.hash;

export const supabase = createClient(url, key);

/**
 * Unwraps a supabase-js result, throwing its error instead of returning it.
 * There are no generated DB types here, so the row type comes from the
 * caller's declared return type (the shapes in data.ts, read off the live
 * schema dump).
 */
export function must<T>(result: { data: unknown; error: { message: string } | null }): T {
  if (result.error) throw new Error(result.error.message);
  return result.data as T;
}
